import { Button, Checkbox, Modal } from "antd";
import React, { useState } from "react";

import { accType } from "../terjadwal/constants";
import TextInfo from "./TextInfo";



const AddUpload = ({
    errors,
    onImageChange,
    handleUploadImage,
    sbgImg,
    sbgImg2,
    ktpNasabahImg,
    ktpPenerimaImg,
}) => {

    const [check, setCheck] = useState(false);

    const onChangePawnType = (e) => {
        setCheck(e);
    }
    return (
        <>
            <div className="modal-form-content mt-3">
                <TextInfo
                    title="SBG Pelunasan"
                    type={"upload"}
                    id={"sbg"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("sbg")}
                    fileList={sbgImg}
                    error={errors?.sbg}
                    customRequest={handleUploadImage("sbg")}
                    isForm
                />
                <TextInfo
                    title="SBG Pelunasan 2"
                    type={"upload"}
                    id={"sbg_2"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("sbg_2")}
                    fileList={sbgImg2}
                    error={errors?.sbg_2}
                    customRequest={handleUploadImage("sbg_2")}
                    isForm
                />
                <TextInfo
                    title="KTP Nasabah"
                    type={"upload"}
                    id={"ktpNasabah"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("ktpNasabah")}
                    fileList={ktpNasabahImg}
                    error={errors?.ktpNasabah}
                    customRequest={handleUploadImage("ktpNasabah")}
                    isForm
                />
            </div>
            <div className="">
                <div className="d-flex justify-content-start">
                    <label className="color-A6A6A6">KTP Penerima </label>
                    <Checkbox.Group
                        className="pawn-type-checkbox"
                        options={accType}
                        onChange={onChangePawnType}
                        style={{ marginLeft: 115 }}
                    />
                </div>
                <div className="modal-form-content mt-2" style={{ display: (check == false) ? "" : "none" }} >
                    <TextInfo
                        type={"upload"}
                        id={"ktpPenerima"}
                        helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                        customRequest={handleUploadImage("ktpPenerima")}
                        handleImageChange={onImageChange("ktpPenerima")}
                        fileList={ktpPenerimaImg}
                        error={errors?.ktpPenerima}
                        isForm
                    />
                </div>
            </div>
        </>
    );
};

export default AddUpload;

